<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">数据通道</div>
          <div class="content">提供P2P网络穿透服务以及服务端/用户端到分布式节点之间的数据传输服务</div>
        </div>
        <div class="right-banner">
          <img
            class=""
            src="./../assets/dataChanel/banner.png"
            alt="沐桦科技"
          />
        </div>
      </div>
    </div>
    <section class="advantage-wrap">
      <div class="muhua-title advantage-title">产品优势</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dataChanel/plat.png"
              alt=""
            >
            <div class="card-title ">多平台支持</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dataChanel/distributed.png"
              alt=""
            >
            <div class="card-title ">分布式节点</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dataChanel/config.png"
              alt=""
            >
            <div class="card-title ">灵活配置</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/dataChanel/reliable.png"
              alt=""
            >
            <div class="card-title ">高可靠</div>
          </div>
        </div>
      </div>
    </section>
    <section class="application-warp">
      <div class="muhua-title ">应用场景</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/dataChanel/social.png"
              alt="沐桦科技"
            />
            <div class="help-title">社交网络</div>
            <div class="help-content">提供P2P隐私社交，摆脱服务器数据窥探。</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/dataChanel/edu.png"
              alt="沐桦科技"
            />
            <div class="help-title">在线会议/教育</div>
            <div class="help-content">企业远程语音或视频会议，多点两两连接稳定传输；桌面、画板、讲解者等视角无延时、无卡顿切换。</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/dataChanel/monitor.png"
              alt="沐桦科技"
            />
            <div class="help-title">远程监控</div>
            <div class="help-content">安全访问内网摄像头，省去公网服务器部署成本、节省带宽成本。</div>
          </div>
        </div>
      </div>
    </section>
    <section class="compare">
      <div class="muhua-title">基于数据通道的传输与传统服务器中转对比</div>
      <img
        src="./../assets/dataChanel/compare.png"
        alt=""
      >
    </section>
     <section class="product-detail height-220">
      <div class="muhua-title advantage-title">了解如何使用沐桦动态数据通道服务</div>
      <div class="detail-wrap">
        <router-link to="/useDoc" class="button compute disable-button" >查看产品文档</router-link>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import Header from "@/components/Header.vue";

export default {
  name: "home",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      activeIndex: '2-4'
    };
  },
  computed: mapState({}),
  created() {},
  methods: {
    ...mapActions([""])
  }
};
</script>

<style scoped lang="stylus">
.compare {
  background: rgba(255, 255, 255, 1);
  text-align: center;
  img{
      width: 840px;
      margin-bottom: 50px;
  }
}

.application-warp {
  background: rgba(248, 252, 255, 1);

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;

    .card-wrap {
      width: 33%;

      .card {
        margin: 0 auto;
        text-align: center;

        img {
          width: 80px
          height: 66px;
        }

        .help-title {
          font-size: 11px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 20px;
           margin: 22px 0 13px;
        }

        .help-content {

          max-width: 180px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116,133,152,1);
          line-height: 22px;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116,133,152,1);
          line-height: 24px;
          margin: 9px auto 84px;

        }

        .button {
          width: 93px;
          height: 27px;
          background: rgba(0, 174, 239, 1);
          border-radius: 2px;
          border: 1px solid rgba(0, 174, 239, 1);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 12px;
        }
      }
    }
  }
}

 .banner {
    background: #282A3C;
    width: 100%;
    height: 400px;

    display: flex;

    .banner-content {
      width: 80%;
      margin: 0 auto;
      display: flex;
      max-width: 1200px;
    }

    .left-banner {
      width: 59%;

      .title {
        margin: 121px 0 19px 0;
        font-size: 38px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #fff;
        line-height: 64px;
      }

      .content {
        width: 383px;
        height: 90px;
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        line-height: 23px;
        margin-bottom: 27px;
        font-size: 18px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #fff;
        line-height: 32px;
      }

      .know-more {
        width: 96px;
        height: 31px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        font-size: 11px;
        font-weight: 400;
        color: rgba(40, 42, 60, 1);
        line-height: 20px;
        text-align: center;
        line-height: 31px;
      }
    }

    .right-banner {
      width: 41%;

      img {
        height: 400px;
      }
    }
  }

.advantage-wrap {
  background: rgba(255, 255, 255, 1);

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;

    .card-wrap {
      width: 25%;

      .card {
        margin: 0 auto;
        text-align: center;
      }

      img {
        width: 144px;
        height: 144px;
        background: rgba(255, 255, 255, 1);
        margin-botton: 14px;;
      }

      .card-title {
        font-size: 11px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin: 19px 0 96px;
      }
    }
  }
}

.product-detail {
    background-image: url('../assets/background/white_point.png');
    background-size: cover;
    .detail-wrap {
      display: flex;
      justify-content: center;
    }
  }
</style>
